module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-02.1f87898f.png";